/* eslint-disable import/prefer-default-export */
/**
 * Which of the requested uids still need a Community identity fetched.
 *
 * ⚠️ Lives here rather than in `watchers.ts` on purpose. Redux-Witness treats a watchers module
 * as a bag of watcher creators: `createWatchers` iterates EVERY export, calls it, and throws
 * "witness creator must return a valid Effect" on anything that returns something else. That
 * throw happens inside `createStore`, so one stray helper export takes the whole app down before
 * it renders — a blank, unclickable page rather than a scoped failure.
 *
 * Pure and separate also means it is testable without the watcher harness, which is
 * `describe.skip`ped.
 */
export function selectBackfillUids (
  requestedUids: Array<number | string> | undefined,
  currentUid: string,
  isCached: (uid: string) => boolean,
): string[] {
  if (!Array.isArray(requestedUids)) return []
  // ⚠️ Drop falsy ids BEFORE stringifying. `String(0)` is `'0'`, which is truthy, so filtering
  // after the map lets a zero uid through and fetches a profile that cannot exist.
  const normalised = requestedUids.filter(Boolean).map((uid) => String(uid))
  return Array.from(new Set(normalised))
    .filter((uid) => uid !== currentUid && !isCached(uid))
}
